<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <div class="content">
      <div class="con-main">
        <papernav></papernav>

        <div class="con-left">
          <div class="con-left-title">
            <div class="con-left-title-nav">{{ ntitle }}</div>
          </div>
          <div class="con-left-list">
            <div class="con-left-list-tips" v-if="zxzxlist.length===0">该栏目暂无文章</div>
            <div class="con-left-list-con">
              <div
                class="con-left-lists"
                v-for="(item, key) in zxzxlist"
                :key="key"
              >
                <div class="con-left-lists-title">
                  <div
                    class="con-left-lists-title-nr"
                    @click="clickview(item.Id, item.nphtype)"
                  >
                    {{ item.title }}
                  </div>
                  <div class="con-left-lists-title-time">
                    {{ item.writer }}
                  </div>
                </div>
              </div>
            </div>
            <div class="con-left-fy" v-if="zxzxlist.length>0">
              <el-pagination
                background
                :current-page="pIndex"
                :default-page-size="pSize"
                layout="prev, pager, next"
                :total="total"
                @current-change="fenye"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<style scoped>
::v-deep .el-carousel__container {
  height: 200px;
}
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
a:link,
a:visited {
  text-decoration: none;
  color: #333;
}
a:hover {
  color: #777;
}
.con-left {
  float: right;
  width: 900px;
  height: auto;
  padding-top: 30px;
}

.con-left-title {
  border-bottom: 3px double #333;
  font-weight: bold;
  padding: 20px 0 10px 0;
  box-sizing: border-box;
}
.con-left-title:after {
  content: "";
  display: table;
  clear: both;
}
.con-left-title-nav {
  float: left;
  height: 30px;
  line-height: 30px;
  margin-right: 10px;
  font-size: 18px;
}
.con-left-lists {
  border-bottom: 1px dashed #ccc;
}
.con-left-lists:hover {
  background: #fafafa;
}
.con-left-lists-title {
  padding: 10px 0;
}
.con-left-lists-title:after {
  content: "";
  display: table;
  clear: both;
}
.con-left-lists-title-nr {
  width: 80%;
  float: left;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.con-left-lists-title-nr:hover {
  color: #2fadc6;
}
.con-left-lists-title-time {
  width: 20%;
  float: right;
  text-align: right;
  font-size: 14px;
  color: #777;
  height: 30px;
  line-height: 30px;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.con-left-lists-con {
  font-size: 14px;
  color: #555;
  line-height: 24px;
  height: 48px;
  overflow: hidden;
  text-align: justify;
  cursor: pointer;
}
.con-left-fy {
  padding: 30px 0;
}
.con-left-title-nav-sbu {
  color: #999;
  font-size: 14px;
  padding-left: 20px;
}
.con-left-title-nav-sbu > span {
  color: #f00;
  padding: 0 5px;
}
.con-left-list-tips{
  color: #999;
  padding: 30px 0 0 0;
}
</style>

<script setup>
import { get } from "@/utils/index";
import { ref, reactive } from "vue";
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();
// 最新资讯列表
let zxzxlist = reactive([]);
// 分页
let pSize = ref(20);
let pIndex = ref(1);
pIndex.value=store.state.pageindextemp
let total = ref(0);
// 标题
let ntitle = ref("");
// 链接参数
let dflid = ref("");
dflid.value = router.currentRoute.value.query.dflid;
switch (dflid.value) {
  case "1":
    ntitle.value = "教育研究";
    break;
  case "2":
    ntitle.value = "科技探索";
    break;
  case "3":
    ntitle.value = "健康科普";
    break;
  case "4":
    ntitle.value = "思政一体";
    break;
  case "5":
    ntitle.value = "美育融合";
    break;
  case "6":
    ntitle.value = "心理聚焦";
    break;
  case "7":
    ntitle.value = "学校发展";
    break;
  case "8":
    ntitle.value = "技术报告";
    break;
  default:
    ntitle.value = "教育研究";
    break;
}
// 获取该栏目下全部文章
const getzxzx = () => {
  get("/api/NewsPaper/GetArticleListByType", {
    type: dflid.value,
    page: pIndex.value,
    pagesize: pSize.value,
  }).then((res) => {
    // console.log(res)
    total.value = res.Total;
    zxzxlist.length = 0;
    zxzxlist.push(...res.Data);
  });
};
getzxzx();
// 分页
const fenye = (value) => {
  pIndex.value = value;
  getzxzx();
};
// 跳转
const clickview = (id, data) => {
  // 保存临时页码
  store.commit("updatepageindextemp",pIndex.value)
  // 判断是报纸还是期刊跳转不同的详情页   "/jyyj/wzxq", 期刊     "/jkkp/wzxq", 报纸
  let path = "";
  switch (data) {
    case 1:
      path = "/jkkp/wzxq";
      break;
    case 2:
      path = "/jyyj/wzxq";
      break;
  }
  router.push({
    path: path,
    query: {
      wzid: id, //文章id
    },
  });
};
</script>
